export const DAY_NAMES = ['ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ', 'ВС'];
export const RANGE_DELIMITER = '–';

export const MS_IN_DAY = 1000 * 60 * 60 * 24;
